import { RefObject, useLayoutEffect, useRef } from 'react';

/** Fill the space below the report toolbar without growing with the row count. */
export function usePnlGridViewport(visible: boolean): RefObject<HTMLDivElement> {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!visible || !element) return undefined;

    const updateHeight = (): void => {
      let bottomSpacing = 0;
      for (let parent = element.parentElement; parent; parent = parent.parentElement) {
        const style = window.getComputedStyle(parent);
        bottomSpacing += (parseFloat(style.paddingBottom) || 0) + (parseFloat(style.borderBottomWidth) || 0);
      }
      const height = Math.max(200, window.innerHeight - element.getBoundingClientRect().top - Math.max(24, bottomSpacing));
      element.style.setProperty('--sg-pnl-grid-height', `${Math.floor(height)}px`);
    };

    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    if (element.parentElement?.parentElement) observer.observe(element.parentElement.parentElement);
    window.addEventListener('resize', updateHeight);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateHeight);
    };
  }, [visible]);

  return ref;
}
